import { createSignal, For, onMount, Show } from "solid-js";
import { useSFetch } from "../hooks/sfetch";
import { User } from "../components/UserContextProvider";
import { useParams } from "@solidjs/router";
import Text from "../components/Text";
import { EmptyState } from "../components/EmptyState";
import { useTranslation } from "../hooks/useTranslation";
import { formatDateTime } from "../services/dateFormat";

interface AuditLog {
    id: number;
    action: string;
    description: string;
    createdAt: string;
    executorUserId: string;
}

export function AuditLogs() {

    const sfetch = useSFetch();
    const { t } = useTranslation();
    const [auditLogs, setAuditLogs] = createSignal<AuditLog[]>([]);
    const [loading, setLoading] = createSignal(true);
    const [users, setUsers] = createSignal<User[]>([]);
    const params = useParams();

    onMount(async () => {
        const [usersRes, logsRes] = await Promise.all([
            sfetch('/api/User/Users'),
            sfetch('/api/User/AuditLog' + (params.id ? "/" + params.id : ""))
        ]);
        if (usersRes.ok) setUsers(usersRes.value ?? []);
        if (logsRes.ok) setAuditLogs(logsRes.value ?? []);
        setLoading(false);
    });

    return (
        <div class="dashboard-page">
            <h1><Text val="AUDITLOGS" /></h1>
            <Show when={loading()}>
                <p class="gray"><Text val="LOADING" /></p>
            </Show>
            <Show when={!loading() && auditLogs().length === 0}>
                <EmptyState illustration="audit" title={t("AUDIT_NO_ENTRIES")} />
            </Show>
            <Show when={!loading() && auditLogs().length > 0}>
                <div class="v">
                    <For each={auditLogs()}>
                        {auditLog => (
                            <div class="fcard v">
                                <div class="h" style={{ "justify-content": "space-between", "align-items": "center" }}>
                                    <strong>{auditLog.action}</strong>
                                    <span class="gray">
                                        {formatDateTime(auditLog.createdAt)}
                                    </span>
                                </div>
                                <Show when={users().find(user => user.id === auditLog.executorUserId)}>
                                    <div class="h" style={{ "align-items": "center", gap: "var(--spacing-sm)" }}>
                                        <img
                                            style={{ width: "24px", height: "24px", "border-radius": "var(--radius-sm)" }}
                                            src={"https://mineskin.eu/helm/" + users().find(user => user.id === auditLog.executorUserId)?.minecraftUUID + "/100.png"}
                                        />
                                        <span>{users().find(user => user.id === auditLog.executorUserId)?.username}</span>
                                    </div>
                                </Show>
                                <p class="gray">{auditLog.description}</p>
                            </div>
                        )}
                    </For>
                </div>
            </Show>
        </div>
    );
}
